<template>
  <div>
    <b-table
      :fields="tabela.fields"
      :items="items"
      class="mt-3"
      show-empty
      responsive="sm"
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      head-variant="light"
      striped
      hover
    >
      <template #cell(acoes)="item">
        <div class="flex">
          <b-dropdown variant="outline-default">
            <b-dropdown-item @click="excluir(item)">
              {{ $t('GERAL.EXCLUIR') }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
    </b-table>
  </div>
</template>
<script>
export default {
  name: 'TabelaPeriodoLetivo',
  props: {
    items: {
      type: Array,
      default: Array,
    },
  },

  data() {
    return {
      tabela: {
        fields: [
          {
            key: 'descricao',
            label: 'Turma',
            sortable: true,
          },
          {
            key: 'cursoDescricao',
            label: 'Curso',
            sortable: true,
          },
          {
            key: 'acoes',
            label: 'Ações',
          },
        ],
      },
    };
  },
  methods: {
    excluir(item) {
      this.$emit('excluir', item);
    },
  },
};
</script>
